
// Set Vars
/////////////////////////////////////////////////////////
var svgEl         = document.body.querySelectorAll('svg');
var vbmInImgs     = document.querySelectorAll('.vbmInImg');
var vbmInImgLas   = document.querySelectorAll('.vbmInImgLa');

var vbmLogoImgs   = document.querySelectorAll('.vbmLogoImg');
var vbmOTHImg     = document.querySelectorAll('.vbmOTHImg');

var delBtn        = '<span class="delBtn">X</span>';
var delBtnCl      = document.querySelectorAll('.delBtn');
  
var genContainers = document.querySelectorAll('#vbmISC');
var switchRatios  = document.querySelectorAll('#switchRatio');
var vbmOPI        = '';
var dldbtns       = document.querySelectorAll('.generateImg');
var _URL          = window.URL || window.webkitURL;
var coImg         = '';

var inputTxt      = document.getElementById('vbmTxtInput');
var outputName    = 'BeB-WWH-Social.png';


// Update user img width input
/////////////////////////////////////////////////////////

vbmInImgLas.forEach(function (vbmInImgLa, index) {
  
  vbmInImgLa.addEventListener('click', (event) => {
    var parent = event.target.closest('.vbmUpBtnWr');
    var uploadInput = parent.querySelector('.imgInp');

    uploadInput.click();

  });

});

function createCloseBtn(appEl) {
  const newContainer = document.createElement('span');
  newContainer.classList.add('delBtn');
  newContainer.innerHTML = 'X';

  appEl.appendChild(newContainer)
}

vbmInImgs.forEach(function (vbmInImg, index) {

  vbmInImg.addEventListener('change', (event) => {

    var image, file;
    var parent = event.target.closest('.vbmGenWrapper');
    var vbmOPI = parent.querySelector('#vbmOPI');

    if ((file = vbmInImg.files[0])) {
      image = new Image();
      image.onload = function() {
        src = image.src;
        // jQuery(vbmOPI).html('<img src="'+ src +'" class="cuImg"><img class="coImg" src="'+ coImg +'" alt="multiplyimg">');
        //$('#vbmOPI').css('background-image', 'url(' + src + ')');
        vbmOPI.innerHTML = '<img id="dragImg" src="'+ src +'" class="cuImg dragImg">';
        
        event.preventDefault();
      }
    }; 
    image.src = _URL.createObjectURL(file);
  });
});

vbmLogoImgs.forEach(function (vbmLogoImg, index) {

  vbmLogoImg.addEventListener('change', (event) => {

    var image, file;
    var parent = event.target.closest('.vbmGenWrapper');
    var vbmOPI = parent.querySelector('#vbmOTH');

    if ((file = vbmLogoImg.files[0])) {
      image = new Image();
      image.onload = function() {
        src = image.src;
        // jQuery(vbmOPI).html('<img src="'+ src +'" class="cuImg"><img class="coImg" src="'+ coImg +'" alt="multiplyimg">');
        //$('#vbmOPI').css('background-image', 'url(' + src + ')');
        vbmOPI.innerHTML = '<img src="'+ src +'" class="vbmOTHImg">';

        //vbmOPI.appendChild('<span class="delBtn">X</span>');

        createCloseBtn(vbmOPI);

        var delBtnCl = parent.querySelector('.delBtn');
        delBtnCl.addEventListener('click', (event) => {
          
          vbmOPI.innerHTML = '';

        });
        
        event.preventDefault();
      }
    }; 
    image.src = _URL.createObjectURL(file);
  });
});

if (typeof(vbmOTHImg) != 'undefined' && vbmOTHImg != null) {

  vbmLogoImgs.forEach(function (vbmLogoImg, index) {

    var parent = vbmLogoImg.closest('.vbmGenWrapper');
    var vbmOPI = parent.querySelector('#vbmOTH');

    //vbmOPI.innerHTML = vbmOPI.innerHTML + delBtn;

    createCloseBtn(vbmOPI);

    var delBtnCl = parent.querySelector('.delBtn');
    delBtnCl.addEventListener('click', (event) => {
      
      vbmOPI.innerHTML = '';

    });

  });

}

// Set drag Image by key
////////////////////////////////////////////////////////////

window.addEventListener("keydown", moveImage);
function moveImage(e) {
  var dragImg = document.querySelector('#vbmIGW_postGen #dragImg');
  var dragImgPro = document.querySelector('#vbmIGW_postGen #dragImg');
  if (dragImg) {
    switch (e.keyCode) {
      case 37:
        dragImg.style.left = parseInt(dragImg.offsetLeft) - 5 + 'px';
        break;
      case 39:
        dragImg.style.left = parseInt(dragImg.offsetLeft) + 5 + 'px';
        break;
    }
 } else if (dragImgPro) {
    switch (e.keyCode) {
      case 37:
        dragImgPro.style.left = parseInt(dragImgPro.offsetLeft) - 5 + 'px';
        break;
      case 39:
        dragImgPro.style.left = parseInt(dragImgPro.offsetLeft) + 5 + 'px';
        break;
    }
 }  
}

// Update TXT Function
/////////////////////////////////////////////////////////



/*
vbmChangeText(inputTxt);
function vbmChangeText(input) {
  input.onkeyup = function() {
    outputName = input.value + '.png';
  }

  console.log(outputName);

}
*/

// Switch Aspect Ratio
////////////////////////////////////////////////////////////

switchRatios.forEach(function (switchRatio, index) {
  switchRatio.addEventListener('change', (event) => {

    let parent = event.target.closest('.vbmGenWrapper');
    let genContainer = parent.querySelector('#vbmISC');
    let isChecked = event.target.checked;
    
    if (isChecked == true) {
      genContainer.classList.add('ratio-4-5');
    } else {
      genContainer.classList.remove('ratio-4-5');
    }
  });
});

// Set Element width and Height for rendering
/////////////////////////////////////////////////////////
function vbmSetWiHi(el) {
  el.forEach(function(item) {
    item.setAttribute("width", item.getBoundingClientRect().width);
    item.setAttribute("height", item.getBoundingClientRect().height);
    item.style.width = null;
    item.style.height= null;
  });
}

// Remove Element width and Height for rendering
/////////////////////////////////////////////////////////
function vbmRemWiHi(el) {
  el.forEach(function(item) {
    item.removeAttribute("width");
    item.removeAttribute("height");
  });
}

// SetUp Color Picker
/////////////////////////////////////////////////////////
/* 

var colorBox = document.querySelector('#vbmISC');

Coloris.setInstance('.colorPicker', {
  theme: 'pill',
  alpha: false,
  onChange: (color, inputEl) => {
    colorBox.style.background = color;
  }
});

*/
// create canvas container
/////////////////////////////////////////////////////////

// Download canvas img on btn click
/////////////////////////////////////////////////////////
dldbtns.forEach(function (dldbtn, index) {
  // dldbtn.addEventListener('click', vbmCreateCanvas);  
  dldbtn.addEventListener('click', (event) => {
    var parentBox   = event.target.closest('.vbmGenWrapper');
    var canBox      = parentBox.querySelector('#vbmISC');
    var canBoxWi    = canBox.offsetWidth;
    var canBoxHi    = canBox.offsetHeight;
    var canBoxOffY  = canBox.offsetTop;
    var canBoxOffX  = canBox.offsetLeft;
    var scaleFac    = 1080 / canBoxWi;
    var inputTxtVal = inputTxt.value.replace(/\s+/g, '-');
    var delBtn      = parentBox.querySelector('.delBtn');

    // Hide an element
    var show = function (elem) { elem.style.display = 'block'; };

    // Hide an element
    var hide = function (elem) { elem.style.display = 'none'; };

    outputName = 'BeB-#workwithheart-Sharing-' + inputTxtVal + '.png';

    if(delBtn) {hide(delBtn);}
    
    vbmSetWiHi(svgEl);

    html2canvas(canBox, {
      scale: scaleFac,
      width: canBoxWi,
      height: canBoxHi,
      useCORS: true,
    }).then( canvas => {
      
      // document.body.appendChild(canvas)
      
      canvas.setAttribute("id", "vbmCR");
      
      canvas.toBlob(function(blob) {
        saveAs(blob, outputName);
      }, "image/png");
    
      vbmRemWiHi(svgEl);
      if(delBtn){ show(delBtn); }
    });
  });
});

